import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.css']
})
export class ConfirmationPopupComponent implements OnInit {

  @Input() show: boolean = false;
  @Input() header: string = "Insert header"
  @Input() message: string = "Insert message"
  @Input() button1Text: string = "button1 text"
  @Input() button2Text: string = "button2 text"
  @Output() button1Action = new EventEmitter<any>();
  @Output() button2Action = new EventEmitter<any>();


  constructor() { }

  ngOnInit(): void {
  }

  onClickButton1(event: any){
    this.button1Action.emit(event);
  }

  onClickButton2(event: any){
    this.button2Action.emit(event);
  }

}
